import { getOr, pick } from 'lodash/fp';

const DELAY_IN_MS = 100;
const pickMock = pick(['result', 'request', 'response', 'headers']);
const getDelay = getOr(DELAY_IN_MS, ['delay']);

export default (mock) =>
  function* ({ timeout }) {
    const delay = getDelay(mock);

    yield timeout(delay);

    return pickMock(mock);
  };
